import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { getform, deleteforms } from "../../ReduxToolkit/Slice/Feedback/Form";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import logo from "../../img/logo.png";

function Form() {
  const dispatch = useDispatch();
  const { status, forms } = useSelector((state) => state.form);
  //  get
  useEffect(() => {
    if (status === "idle") {
      dispatch(getform());
    }
  }, [dispatch, status]);
  // delete api
  const handleDelete = (formid) => {
    const Isconfirmed = window.confirm(
      "Are you sure! you want delete this Feedback?"
    );
    if (Isconfirmed) {
      dispatch(deleteforms(formid));
    }
  };
  // single data fetch
  const [profile, setProfile] = useState("");
  const [name, setName] = useState("");
  const [fatherName, setFatherName] = useState("");
  const [motherName, setMotherName] = useState("");
  const [dob, setDob] = useState("");
  const [qualification, setQualification] = useState("");
  const [courseApplied, setCourseApplied] = useState("");
  const [religion, setReligion] = useState("");
  const [nationality, setNationality] = useState("");
  const [maritalStatus, setMaritalStatus] = useState("");
  const [caste, setCaste] = useState("");
  const [address, setAddress] = useState("");
  const [pincode, setPincode] = useState("");
  const [currentAddress, setCurrentAddress] = useState("");
  const [currentPincode, setCurrentPincode] = useState("");
  const [emailID, setEmailID] = useState("");
  const [mobile, setMobile] = useState("");
  const [guardianMobile, setGuardianMobile] = useState("");
  const [signatureOfGuardian, setSignatureOfGuardian] = useState("");
  const [signatureOfApplicant, setSignatureOfApplicant] = useState("");
  const [tenthNameOfSchool, setTenthNameOfSchool] = useState("");
  const [tenthBoard, setTenthBoard] = useState("");
  const [tenthYear, setTenthYear] = useState("");
  const [tenthRoll, setTenthRoll] = useState("");
  const [tenthMarks, setTenthMarks] = useState("");
  const [twelfthNameOfSchool, setTwelfthNameOfSchool] = useState("");
  const [twelfthBoard, setTwelfthBoard] = useState("");
  const [twelfthYear, setTwelfthYear] = useState("");
  const [twelfthRoll, setTwelfthRoll] = useState("");
  const [twelfthMarks, setTwelfthMarks] = useState("");
  const [selectedId, setSelectedId] = useState(null);
  const handleId = (id) => {
    const selectedForm = forms.data.find((form) => form._id === id);
    if (selectedForm) {
      // Existing state updates...
      setProfile(selectedForm.Profile || "");
      setName(selectedForm.name || "");
      setFatherName(selectedForm.fatherName || "");
      setMotherName(selectedForm.MotherName || "");
      setDob(selectedForm.Dob || "");
      setQualification(selectedForm.qualification || "");
      setCourseApplied(selectedForm.curseApplied || "");
      setReligion(selectedForm.religion || "");
      setNationality(selectedForm.nationality || "");
      setMaritalStatus(selectedForm.maritalStatus || "");
      setCaste(selectedForm.caste || "");
      setAddress(selectedForm.address || "");
      setPincode(selectedForm.pincode || "");
      setCurrentAddress(selectedForm.currentAddress || "");
      setCurrentPincode(selectedForm.currentPincode || "");
      setEmailID(selectedForm.EmailID || "");
      setMobile(selectedForm.mobile || "");
      setGuardianMobile(selectedForm.gaurdianmobile || "");
      setSignatureOfGuardian(selectedForm.signatureofgaurdian || "");
      setSignatureOfApplicant(selectedForm.signatureofapplicent || "");

      // New state updates for educational details
      setTenthNameOfSchool(selectedForm.tenth.nameofschool || "");
      setTenthBoard(selectedForm.tenth.board || "");
      setTenthYear(selectedForm.tenth.year || "");
      setTenthRoll(selectedForm.tenth.roll || "");
      setTenthMarks(selectedForm.tenth.marks || "");

      setTwelfthNameOfSchool(selectedForm.twelfth.twelfthNameofschool || "");
      setTwelfthBoard(selectedForm.twelfth.twelfthBoard || "");
      setTwelfthYear(selectedForm.twelfth.twelfthYear || "");
      setTwelfthRoll(selectedForm.twelfth.twelfthRoll || "");
      setTwelfthMarks(selectedForm.twelfth.twelfthMarks || "");

      setSelectedId(id);
    }
  };
  // pdf
  
  const handleDownloadPDF = () => {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();
  
    // Logo
    const logoHeight = 25;
    const logoWidth = 25;
    const logoX = (pageWidth - logoWidth) / 2;
    doc.addImage(logo, "PNG", logoX, 10, logoWidth, logoHeight);
  
    // Header
    const headerStartY = 10 + logoHeight + 5;
    doc.setFontSize(16);
    doc.setFont("helvetica", "bold");
    doc.text("Daksh B.Sc Nursing College & Hospital", pageWidth / 2, headerStartY, { align: "center" });
  
    doc.setFontSize(12);
    doc.setFont("helvetica", "normal");
    doc.text("Add - Dhanauti, Daraundha, Siwan - 841233", pageWidth / 2, headerStartY + 8, { align: "center" });
  
    // Basic Info (1 to 9)
    let y = headerStartY + 25;
    const lineSpacing = 10;
  
    const info = [
      `1. STUDENT NAME : ${name.toUpperCase()}`,
      `2. FATHER'S NAME : ${fatherName.toUpperCase()}`,
      `3. D.O.B : ${dob.toUpperCase()}`,
      `4. MOTHER NAME : ${motherName.toUpperCase()}`,
      `5. QUALIFICATION : ${qualification.toUpperCase()}`,
      `6. COURSE : ${courseApplied.toUpperCase()}`,
      `7. CONTACT NO: ${mobile}`,
      `8. MAIL ID: ${emailID.toUpperCase()}`,
    ];
  
    // Draw each info line
    info.forEach((line, index) => {
      doc.text(line, 15, y + index * lineSpacing);
    });
  
    // Profile image: aligned with the first line (Student Name)
    const profileX = pageWidth - 50;
    const profileY = y; // Same as line 1 (Student Name)
    const profileWidth = 30;
    const profileHeight = 35;
    doc.addImage(profile, "PNG", profileX, profileY, profileWidth, profileHeight);
  
    // Education Details Table
    autoTable(doc, {
      startY: y + info.length * lineSpacing + 10,
      head: [["S. No", "Board", "Year of Passing", "Percentage"]],
      body: [
        ["1", tenthBoard, tenthYear, `${tenthMarks}%` || ""],
        ["2", twelfthBoard, twelfthYear, `${twelfthMarks}%` || ""],
      ],
      theme: "grid",
      headStyles: {
        fillColor: [60, 60, 60], 
      },
    });
  
    // Signature just below the profile image (tight)
    const signatureY = profileY + profileHeight + 5;
    const signatureWidth = 30;
    const signatureHeight = 12;
    doc.addImage(signatureOfApplicant, "PNG", profileX, signatureY, signatureWidth, signatureHeight);
  
    // Save the PDF
    doc.save(`EntranceForm_${name.toUpperCase()}.pdf`);
  };

  
  

  return (
    <>
      <div>
        <div className="d-flex justify-content-between my-3">
          <h3>Entrance Form </h3>
        </div>
        <div className="table-responsive">
          <table className="table table-hover">
            <thead className="table-primary">
              <tr>
                <th scope="col">S.no</th>
                <th scope="col">Name</th>
                <th scope="col">Date of Birht</th>
                <th scope="col">Address</th>
                <th scope="col">Qualification</th>
                <th scope="col">date</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              {status === "loading" && (
                <tr className="my-2">
                  <td colSpan={8}>
                    <Skeleton count={10} height={90} />
                  </td>
                </tr>
              )}
              {status === "failed" && (
                <tr>
                  <td colSpan={8}>
                    <p className="text-center fw-bold">{"Data not found"}</p>
                  </td>
                </tr>
              )}
              {status === "succeeded" &&
                forms.data &&
                forms.data.map((form, index) => {
                  const newdate = new Date(form.createdAt);
                  const formattedDate = newdate.toLocaleDateString("default", {
                    day: "2-digit",
                    month: "long",
                    year: "numeric",
                  });
                  return (
                    <tr key={form._id}>
                      <th scope="row">{index + 1}</th>
                      <td>{form.name}</td>
                      <td>{form.Dob}</td>
                      <td>{form.address}</td>
                      <td>{form.qualification}</td>
                      <td>{formattedDate}</td>
                      <td className="cursor">
                        <div onClick={() => handleId(form._id)}>
                          <i
                            className="bi bi-eye-fill text-primary fs-5"
                            data-bs-toggle="modal"
                            data-bs-target="#exampleModal"
                          ></i>
                        </div>
                        <div onClick={() => handleDelete(form._id)}>
                          <i className="bi bi-trash text-danger fs-5"></i>
                        </div>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
      </div>

      {/* Modal  */}
      <div
        className="modal fade"
        id="exampleModal"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-xl modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                {""}
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="text-end mt-3">
                  <button
                    className="btn btn-primary"
                    onClick={handleDownloadPDF}
                  >
                    Download PDF
                  </button>
                </div>

                <div className="col-12 col-lg-12 mb-3">
                  <div className="text-center">
                    <img
                      src={profile}
                      alt="Profile"
                      className="rounded-circle"
                      width={100}
                      height={100}
                    />
                    <h6>Profile Picture</h6>
                  </div>
                </div>
                <div className="col-12 col-lg-4 mb-3">
                  <div>
                    <h6>Name</h6>
                    <h6 className="text-primary">{name}</h6>
                  </div>
                </div>
                <div className="col-12 col-lg-4 mb-3">
                  <div>
                    <h6>Date of Birth</h6>
                    <h6 className="text-primary">{dob}</h6>
                  </div>
                </div>
                <div className="col-12 col-lg-4 mb-3">
                  <div>
                    <h6>Email ID</h6>
                    <h6 className="text-primary">{emailID}</h6>
                  </div>
                </div>
                <div className="col-12 col-lg-4 mb-3">
                  <div>
                    <h6>Current Address</h6>
                    <h6 className="text-primary">{currentAddress}</h6>
                  </div>
                </div>
                <div className="col-12 col-lg-4 mb-3">
                  <div>
                    <h6>Qualification</h6>
                    <h6 className="text-primary">{qualification}</h6>
                  </div>
                </div>
                <div className="col-12 col-lg-4 mb-3">
                  <div>
                    <h6>Mobile Number</h6>
                    <h6 className="text-primary">{mobile}</h6>
                  </div>
                </div>
                <div className="col-12 col-lg-4 mb-3">
                  <div>
                    <h6>Father's Name</h6>
                    <h6 className="text-primary">{fatherName}</h6>
                  </div>
                </div>
                <div className="col-12 col-lg-4 mb-3">
                  <div>
                    <h6>Mother's Name</h6>
                    <h6 className="text-primary">{motherName}</h6>
                  </div>
                </div>
                <div className="col-12 col-lg-4 mb-3">
                  <div>
                    <h6>Nationality</h6>
                    <h6 className="text-primary">{nationality}</h6>
                  </div>
                </div>

                <div className="col-12 col-lg-4 mb-3">
                  <div>
                    <h6>Guardian's Mobile</h6>
                    <h6 className="text-primary">{guardianMobile}</h6>
                  </div>
                </div>
                <div className="col-12 col-lg-4 mb-3">
                  <div>
                    <h6>Marital Status</h6>
                    <h6 className="text-primary">{maritalStatus}</h6>
                  </div>
                </div>
                <div className="col-12 col-lg-4 mb-3">
                  <div>
                    <h6>Caste</h6>
                    <h6 className="text-primary">{caste}</h6>
                  </div>
                </div>
                <div className="col-12 col-lg-4 mb-3">
                  <div>
                    <h6>Religion</h6>
                    <h6 className="text-primary">{religion}</h6>
                  </div>
                </div>
                <div className="col-12 col-lg-4 mb-3">
                  <div>
                    <h6>Pincode</h6>
                    <h6 className="text-primary">{pincode}</h6>
                  </div>
                </div>

                <div className="col-12 col-lg-4 mb-3">
                  <div>
                    <h6>10th Grade Details</h6>
                    <ul>
                      <li>
                        <strong>School Name:</strong> {tenthNameOfSchool}
                      </li>
                      <li>
                        <strong>Board:</strong> {tenthBoard}
                      </li>
                      <li>
                        <strong>Year:</strong> {tenthYear}
                      </li>
                      <li>
                        <strong>Roll Number:</strong> {tenthRoll}
                      </li>
                      <li>
                        <strong>Marks:</strong> {tenthMarks}
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-12 col-lg-4 mb-3">
                  <div>
                    <h6>12th Grade Details</h6>
                    <ul>
                      <li>
                        <strong>School Name:</strong> {twelfthNameOfSchool}
                      </li>
                      <li>
                        <strong>Board:</strong> {twelfthBoard}
                      </li>
                      <li>
                        <strong>Year:</strong> {twelfthYear}
                      </li>
                      <li>
                        <strong>Roll Number:</strong> {twelfthRoll}
                      </li>
                      <li>
                        <strong>Marks:</strong> {twelfthMarks}
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-12 col-lg-4 mb-3">
                  <div>
                    <h6>Signature of Applicant</h6>
                    <img
                      src={signatureOfApplicant}
                      alt="Signature of Applicant"
                      style={{ maxWidth: "100px" }}
                      className="rounded"
                    />
                  </div>
                </div>
                <div className="col-12 col-lg-4 mb-3">
                  <div>
                    <h6>Signature of Guardian</h6>
                    <img
                      src={signatureOfGuardian}
                      alt="Signature of Guardian"
                      className="rounded"
                      style={{ maxWidth: "100px" }}
                    />
                  </div>
                </div>
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Form;
